module Environments {
    module.directive("bindDropdown", function () {
        return {
            link: function (scope, element, attrs, ngModel) {
                element.dropdown();
            }
        };
    });
}